import React, { useEffect, useState } from "react";
import {
  allocateToSubAdmin,
  getCustomers,
  getSubAdmins,
} from "../../ApiCalls/Users";
import { useNavigate } from "react-router-dom";

const AdminCustomerAllocation = () => {
  const [formData, setFormData] = useState({
    customerName: "",
    state: "",
    district: "",
    fromDate: "",
    toDate: "",
    status: "active",
    selected: "selected",
    subadmin: "",
  });

  const [customers, setCustomers] = useState([]);
  const [subadmins, setSubadmins] = useState([]);
  const [selectedSubadmin, setSelectedSubadmin] = useState(null);
  const [customerIds, setCustomerIds] = useState([]);
  
  const navigate = useNavigate();
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = () => {
    console.log("Form Data:", formData);
    fetchCustomers();
  };

  const handleSubadminChange = async (id, newSubadmin) => {
    try {
      // console.log("Selected Subadmin ID:", newSubadmin);
      // console.log("Customer ID:", id);

      await allocateToSubAdmin({
        customer: id,
        subadmin: newSubadmin,
      });

      //  Refresh customers list after allocation
      await fetchCustomers();
    } catch (error) {
      console.error("Error updating subadmin:", error);
    }
  };
 
  const SubmitallocateToSubAdmin = async( ) => {
    try {
      // console.log("Subadmin ID:", selectedSubadmin);
      // console.log("Customer IDs:", customerIds);
      if (!selectedSubadmin || customerIds.length === 0) {
        console.error("Please select a subadmin and at least one customer.");
        return;
      }
      const response = await allocateToSubAdmin({
        customer: customerIds,
        subadmin: selectedSubadmin,
      });
      console.log("Allocation successful:", response);
      //  Refresh customers list after allocation
      await fetchCustomers();
    } catch (error) {
      console.error("Error allocating to subadmin:", error);
    }
  }

  const fetchCustomers = async () => {
    try {
      const filters = {
        first_name: formData.customerName,
        state: formData.state,
        district: formData.district,
        date_from: formData.fromDate,
        date_to: formData.toDate,
        is_active: formData.status === "active" ? 1 : 0,
        agent_name: formData.subadmin, // optional
      };
      const response = await getCustomers(filters);
      setCustomers(response.data);
      setCustomerIds(response.data.map((customer) => customer.customer_id));
    } catch (error) {
      console.error("Error fetching customers:", error);
    }
  };

  // fetch subadmins from API

  const fetchSubadmins = async () => {
    try {
      const response = await getSubAdmins();
      console.log("subadmins",subadmins);
      
      setSubadmins(response.data);
    } catch (error) {
      console.error("Error fetching customers:", error);
    }
  };

  useEffect(() => {
    fetchCustomers();
    fetchSubadmins();
  }, []);
  return (
    <div className="w-full bg-white p-4">
      <h2 className="mb-4 text-2xl font-medium text-green-600">
        {" "}
        Customer Allocation
      </h2>
      <div className="w-full border-b pb-5">
        <div className="flex flex-wrap gap-6">
          {[
            {
              label: "Customer Name",
              name: "customerName",
              type: "text",
              placeholder: "Enter Name",
            },
            {
              label: "State",
              name: "state",
              type: "text",
              placeholder: "Enter State",
            },
            {
              label: "District",
              name: "district",
              type: "text",
              placeholder: "Enter District",
            },
            { label: "From Date", name: "fromDate", type: "date" },
            { label: "To Date", name: "toDate", type: "date" },
          ].map((input) => (
            <div key={input.name} className="space-y-2">
              <label htmlFor={input.name} className="font-medium text-gray-700">
                {input.label}
              </label>
              <input
                id={input.name}
                type={input.type}
                name={input.name}
                value={formData[input.name]}
                onChange={handleChange}
                className="w-full rounded border p-2"
                placeholder={input.placeholder}
              />
            </div>
          ))}

          {[
            {
              label: "Status",
              name: "status",
              options: [
                { value: "active", text: "Active" },
                { value: "not active", text: "Not Active" },
              ],
            },
            {
              label: "Selected/Unselected",
              name: "selected",
              options: [
                { value: "selected", text: "Selected" },
                { value: "unselected", text: "Unselected" },
              ],
            },
          ].map((select) => (
            <div key={select.name} className="space-y-2">
              <label
                htmlFor={select.name}
                className="font-medium text-gray-700"
              >
                {select.label}
              </label>
              <select
                id={select.name}
                name={select.name}
                value={formData[select.name]}
                onChange={handleChange}
                className="w-full cursor-pointer rounded border p-2"
              >
                {select.options.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.text}
                  </option>
                ))}
              </select>
            </div>
          ))}
        </div>

        <div className="mt-4">
          <label htmlFor="subadmin" className="font-medium text-gray-700">
            Subadmin
          </label>
          <div className="mt-2 flex gap-6">
            <select
              id="subadmin"
              name="subadmin"
              value={formData.subadmin}
              onChange={handleChange}
              className="max-w-lg cursor-pointer rounded border p-2"
            >
              <option value="">Select Subadmin</option>
              {subadmins?.map((subadmin) => (
                <option key={subadmin.id} value={subadmin.first_name}>
                  {subadmin.first_name}
                </option>
              ))}
            </select>

            <button
              onClick={handleSubmit}
              className="rounded bg-[#05BF02] p-2 px-5 text-white hover:bg-green-700"
            >
              Search
            </button>
          </div>
        </div>
        <div className="flex w-full items-end justify-end gap-4">
          <div className="flex flex-col gap-2">
            <label htmlFor="subadmin" className="font-medium text-gray-700">
              Allocate To SubAdmin
            </label>
            <select
              id="subadmin"
              name="subadmin"
              value={selectedSubadmin}
              onChange={(e) => setSelectedSubadmin(e.target.value)}
              className="max-w-lg cursor-pointer rounded border p-2"
            >
              <option value="">Select Subadmin</option>
              {subadmins?.map((subadmin) => (
                <option key={subadmin.id} value={subadmin.id}>
                  {subadmin.first_name}
                </option>
              ))}
            </select>
          </div>
          <button
            onClick={SubmitallocateToSubAdmin}
            className="rounded bg-[#05BF02] p-2 px-5 text-white hover:bg-green-700"
          >
            Allocate to All
          </button>
        </div>
      </div>

      {/* Table Section */}
      <div className="mt-10 w-full space-y-4">
        <div className="grid min-w-[800px] grid-cols-[2fr,2fr,2fr,2fr,2fr,1fr] pb-2 font-medium text-brand-button-green-bg">
          <div className="text-center">Customer Name</div>
          <div className="text-center">Location</div>
          <div className="text-center">Join Date</div>
          <div className="text-center">Status</div>
          <div className="text-center">Sub Admin</div>
          <div className="text-center">View</div>
        </div>

        {customers?.map((customer) => (
          <div
            key={customer.customer_id}
            className="grid min-w-[800px] grid-cols-[2fr,2fr,2fr,2fr,2fr,1fr] gap-1 py-2"
          >
            <div className="rounded-xl border p-2 text-center">
              {customer?.customer_name}
            </div>
            <div className="rounded-xl border p-2 text-center">
              {customer.location}
            </div>
            <div className="rounded-xl border p-2 text-center">
              {customer.date_joined}
            </div>
            <div className="flex w-full items-center justify-center text-center">
              <span
                className={`rounded px-2 py-1 text-white ${
                  customer.is_allocated ? "bg-green-500" : "bg-red-500"
                }`}
              >
                {customer.is_allocated ? "Allocated" : "Not Allocated"}
              </span>
            </div>
            {/* <div className="rounded-xl border p-2 text-center">{customer.subadmin}</div> */}
            <div className="rounded-xl border p-2 text-center">
              <select
                // value={customer.subadmin_id || ""}
                value={customer.subadmin_id != null ? customer.subadmin_id : ""}
                onChange={(e) =>
                  handleSubadminChange(customer.customer_id, e.target.value)
                }
                className="w-full text-center outline-none"
              >
                <option value="">Select Subadmin</option>
                {subadmins?.map((subadmin) => (
                  <option key={subadmin.id} value={subadmin.id}>
                    {subadmin.first_name}
                  </option>
                ))}
              </select>
            </div>
            <div className="text-center">
              <button
                onClick={() => navigate(`/admin/customers/view/${customer.customer_id}`)}
                className="rounded-lg border border-green-600 px-5 py-2 text-center text-xs font-medium text-green-600 shadow-md transition hover:border-green-700 hover:bg-green-700 hover:text-white sm:text-sm"
              >
                View
              </button>
            </div>
          </div>
        ))}
      </div>

    </div>
  );
};

export default AdminCustomerAllocation;
